export default "__VITE_ASSET__CcXmWdXb__"